export default __webpack_public_path__ + "static/media/img_2.17c3bb13.png";